export default __webpack_public_path__ + "static/media/DataCenter.552d5331.png";